<template lang="">
  <div>
    <div id="list_top">
      <div class="w_1180">
        <h1><strong class="cs_pad3">创业就找创业小鸟</strong>与创新者同行，发现未来</h1>
      </div>
    </div>

    <!--次级导航-->
    <ul class="w_1180 about_tit about_tit2" style="height:auto; overflow:hidden; text-align:center; justify-content: center;">
      <li style="margin-right: 30px;" @click="changeIndex(index)" :class="{active:$route.query.id==item.id}" v-for="(item,index) in addressCategory" :key="item.id">
        <router-link :to="{path:'/address',query:{id:item.id,category_id:6}}">{{item.title}}</router-link>
      </li>
      
      <li style="margin-right: 30px;" :class="{active:$route.query.category_id==1}">
        <router-link :to="{path:'/info',query:{info_category_id:1,category_id:6}}">托管企业公示</router-link>
      </li>
      <li style="margin-right: 30px;" :class="{active:$route.query.category_id==2}">
        <router-link :to="{path:'/info',query:{info_category_id:2,category_id:6}}">失联企业公示</router-link>
      </li>
    </ul>

    <!--主体-->
    <div class="w_1180 cs_pad clearfix">
      <div class="new_add">
        <ul>
          <li v-for="(item, index) in addressWithPics" :key="index" :class="{'l': index % 2 === 0, 'r': index % 2 !== 0}">
            <div v-if="index % 2 === 0" class="left">
              <!-- 左侧内容 -->
              <p class="p1">{{ item.title }}</p>
              <p class="p2">{{ item.en_title }}</p>
              <p class="p3"><a @click="showClusterReserve" :data-id="item.id" style="cursor: pointer">预约看场</a></p>
            </div>
            <div class="right">
              <!-- 右侧内容 -->
              <p class="t" v-show="index % 2 !== 0">{{ item.title }}</p>
              <p class="p">{{ item.description }}</p>
              <nav>
                <a v-for="(item,index) in item.pics"  href="">
                  <img :src="item" alt="">
                </a>
              </nav>
            </div>
            <div v-if="index % 2 !== 0" class="left">
              <!-- 左侧内容 -->
              <img :src="item.picture" alt="">
              <p class="p1">{{ item.subtitle }}</p>
              <p class="p2"><a @click="showClusterReserve" style="cursor: pointer" :data-id="item.id">预约看场</a></p>
            </div>
          </li>
        </ul>
        <div class="clear"></div>
        <div class="about_fenye" id="news_list_page">
          <span><a href="javascript:void(0)" class="">1</a>&nbsp;</span>
          共1页 去第 <input name="" id="targetNavPage" type="text" value="1" class="input"> 页 <input name=""
            data-url="/cluster/category_1.html" type="button" value="确定" class="btn">
        </div>
      </div>
      
    </div>
    <GlobalDialog2 ref="globalDialog2" />
  </div>
</template>
<script>
  import LeftNav from '@/components/leftnavs'
  import pagination from '@/components/pagination'
  export default {
    components: {
      LeftNav,
      pagination
    },
    data() {
      return {
       address:[],
       activeIndex:0,
       addressCategory:[],
       addressCover:[],
       infoCategory:[],
      }
    },
    mounted() {
         this.getAddress()
         this.getAddressCategory()
         this.getInfoCategory()
         this.getAddressCovers()
    },
    computed:{
         combinedCategory(){
          return [...this.addressCategory,...this.infoCategory]
         },
         addressWithPics(){
          return this.address.reduce((acc,addr)=>{
            const pics = this.addressCover.filter(p=>p.link_id===addr.id);
            acc.push({
              ...addr,
              pics:pics.map(pic=>pic.src)
            });
            return acc;
          },[]);
         }
    },
    watch: {
      '$route.query.category_id'(newValue, oldValue) {
      },
      '$route.query.id'(newVal,oldVal){
        this.getAddress()
        this.getAddressCategory()
      }
    },
    methods: {
      changeIndex(index){
       this.activeIndex=index;
      },
      async getAddress(){
        let res = await this.$request.post('address/getAll',{
          category_id:this.$route.query.id
        })
        if (res.data.code===0) {
          this.address=res.data.data
        }
      },
      async getAddressCategory(){
        let res = await this.$request.post('addresscategory/getAll',{ 
        })
        if (res.data.code===0) {
            this.addressCategory=res.data.data
            let cesh=this.addressCategory.filter(item=>item.id==this.$route.query.id)
            document.title=cesh[0].title+'-创业小鸟'
        }
      },
      async getInfoCategory(){
        let res = await this.$request.post('infocategory/getAll')
        if (res.data.code===0) {
            this.infoCategory=res.data.data      
        }
       },
      async getAddressCovers(){
         let res = await this.$request.post('addresscovers/getAll')
         if (res.data.code===0) {
            this.addressCover=res.data.data
         }
      },
      showClusterReserve(){
        this.$refs.globalDialog2.dialogVisible = true;
      }
    },
  }
</script>
<style lang="css" scoped>
  .products_header a {
    cursor: pointer;
  }

  #header_content_right .content a:nth-child(5n) img {
    margin-right: 0;
  }

  .swiper-container {
    height: 300px;
  }

  .swiper-slide {
    /* width: 100px !important; */
  }

  .swiper-slide img {
    width: 94px;
    height: 60px;
  }
</style>